;(function($, _, Modernizr, undefined, window) {
  /**
   * TODO: manager namespace
   * TODO: collapse ? data-target needed / data-parent support
   * TODO: adapter for animations (css3 vs js-based)
   * TODO: mobile don't delegate ? use backdrop ?
   * TODO: keyboard support
   */
  var ModernizrHelper = (function(_Modernizr)
  {
    var ANIMATIONS_MAPPING = {
        'animation'        : 'animationend',
        'OAnimation'       : 'oAnimationEnd',
        'MozAnimation'     : 'animationend',
        'WebkitAnimation'  : 'webkitAnimationEnd'
      },
      TRANSITIONS_MAPPING = {
        'WebkitTransition' : 'webkitTransitionEnd',
        'MozTransition'    : 'transitionend',
        'OTransition'      : 'oTransitionEnd',
        'msTransition'     : 'MSTransitionEnd',
        'transition'       : 'transitionend'
      },
      animEndEventName = ANIMATIONS_MAPPING[_Modernizr.prefixed('animation')],
      transEndEventName = TRANSITIONS_MAPPING[_Modernizr.prefixed('transition')]
    ;

    var getAnimationEndEvent = function() {
      if (!animEndEventName) {
        // explicit for ie8-9 (  ._.)
        return '';
      }

      return animEndEventName;
    };

    var getTransitionEndEvent = function() {
      if (!transEndEventName) {
        // explicit for ie8-9 (  ._.)
        return '';
      }

      return transEndEventName;
    };

    // https://blog.alexmaccaw.com/css-transitions
    var emulateTransitionEnd = function(element, done, duration)
    {
      var called = false,
          $el = $(element),
          transitionEndEventName = getTransitionEndEvent()
      ;

      if (!transitionEndEventName) {
        return done();

        return;
      }

      $el.one(transitionEndEventName, function() {
        called = true;
      });

      var callback = function() {
        if (!called) {
          $($el).trigger(transitionEndEventName);
        }
      };

      setTimeout(callback, duration);
    };

    return {
      'emulateTransitionEnd': emulateTransitionEnd,
      'getAnimationEndEvent': getAnimationEndEvent,
      'getTransitionEndEvent': getTransitionEndEvent
    }
  })(Modernizr);

  var OffieManager = function()
  {
    var NAMESPACE_DEFAULT = '__default__';
    var instances = {
      NAMESPACE_DEFAULT: [],
    };

    $(document).on('click', '[data-toggle="offie-toggle"]', function(event) {
      event.preventDefault();

      var $eventTarget = $(event.target);
      if ('offie-toggle' !== $eventTarget.data('toggle')) {
        $eventTarget = $eventTarget.closest('[data-toggle="offie-toggle"]');
      }

      var $target = findTargetFromTrigger($eventTarget);
      if (null !== $target && $target.data('offie')) {
        $target.data('offie').toggle();
      }
    });

    var findTargetFromTrigger = function($trigger)
    {
      var target = $trigger.data('target');
      if (target) {
        return $(target);
      }

      var $parent = $trigger.closest('[data-toggle="offie-dropdown"], [data-toggle="offie"]');
      if ($parent.length > 0) {
        return $parent;
      }

      return null;
    }

    var getParents = function(childOffieInstance)
    {
      if (!childOffieInstance) {
        return instances;
      }

      var matched = [];
      _.forEach(instances, function(instancesByNamespace, namespace) {
        _.forEach(instancesByNamespace, function (instance) {
          if (instance.getElement().has((childOffieInstance.getElement())[0]).length > 0) {
            matched.push(instance);
          }
        });
      });

      return matched;
    }

    var hasActiveChild = function(namespace)
    {
      for (var i = 0; i < instances[namespace].length; ++i) {
        if (instances[namespace][i].isOpened()) {
          return true;
        }
      }

      return false;
    }

    var closeAll = function(done, except, namespace)
    {
      if (!namespace) {
        namespace = NAMESPACE_DEFAULT;
      }

      if (!instances[namespace]) {
        return done();
      }

      if (!hasActiveChild(namespace)) {
        return done();
      }

      // Close all active child.
      $.each(instances[namespace], function(key, child) {
        var isIgnored = _.find(except, function(v) {
          return child === v;
        });

        if (!isIgnored) {
          child.close();
        }
      });

      return done();
    };

    var register = function(child, namespace)
    {
      if (!namespace) {
        namespace = NAMESPACE_DEFAULT;
      }

      if (!instances[namespace]) {
        instances[namespace] = [];
      }

      instances[namespace].push(child);
    };

    return {
      'closeAll':   closeAll,
      'get':        getParents,
      'getParents': getParents,
      'register':   register,
    }
  };

  var Offie = function(element, options) {
    var DEBOUNCE_WAIT = 150;
    var plugin = this,
        PLUGIN_NAME = 'offie',
        SETTINGS_DEFAULT = {
          'activeClass': PLUGIN_NAME + '--active',
          'animationWait': 500,
          'closingWhitelist': 'a, button',
          'contentSelector': '.dropdown-container',
          'mouseEnabled': false,
          'group': false,
          'triggerSelector': '[data-toggle="offie-toggle"]',
          'wrapperClass': 'js-' + PLUGIN_NAME,
          'wrapperSelector': '.offie-container'
        },
        /*
         * Properties
         */
        settings,
        $element,
        $target,
        $trigger,
        $wrapper,
        opening = false,
        closing = false
    ;

    var init = function(element, options) {
      // Setup the main element.
      $element = $(element);

      // Compute settings / going to the engine ?.
      settings = $.extend(SETTINGS_DEFAULT, $element.data(), options);

      // Infer other elements from main elements and options.
      $element.addClass(settings.wrapperClass);
      $trigger  = $element.children(settings.triggerSelector);

      if (false !== settings.wrapperSelector) {
        $wrapper = $(settings.wrapperSelector);
        if (0 === $wrapper.length) {
          $wrapper = $('body');
        }
      }

      $target = $element;
      var $contentElement = $element.children(settings.contentSelector);
      if ($contentElement.length) {
        $target = $contentElement;
      }

      // Register events.
      if (settings.mouseEnabled) {
        $element.on('mouseenter', _.debounce(onMouseEnter, DEBOUNCE_WAIT));
        $element.on('mouseleave', _.debounce(onMouseLeave, DEBOUNCE_WAIT));
      }
      $trigger.on('touchstart', onTouchHandler);
      $trigger.on('click', onClickHandler);

      // Register this with its manager.
      offieManager.register(plugin, settings.group);

      $element.trigger(buildEvent('init'));
    };

    var onMouseEnter = function(event) {
      plugin.open();
    };

    var onMouseLeave = function(event) {
      plugin.close();
    };

    var onTouchHandler = function(event) {
      event.preventDefault();

      // Toggle the whole thing.
      plugin.toggle(event.target);
    };

    var onClickHandler = function(event) {
      event.preventDefault();
      // Don't propagate for the global click handler (see manager).
      event.stopPropagation();

      // Toggle the whole thing.
      plugin.toggle(event.target);
    };

    var showCallback = function() {
      opening = true;

      $target.addClass(settings.activeClass);

      if ($wrapper && 0 < $wrapper.length) {
        $wrapper.addClass(settings.activeClass);
      }

      if ($trigger.length > 0) {
        // If self-contained trigger, for dropdown, not layer.
        $trigger.addClass(settings.activeClass);
      }

      $element.trigger(buildEvent('showing'));

      $element.one(ModernizrHelper.getTransitionEndEvent(), $.proxy(onShowCompleted, plugin));
      ModernizrHelper.emulateTransitionEnd($element[0], $.proxy(onShowCompleted, plugin), settings.animationWait);
    }

    var onShowCompleted = function()
    {
      opening = false;

      // Enable the global closer handler.
      registerCloserHandler();

      // Trigger some event to assess animation is over.
      $element.trigger(buildEvent('shown'));
      $trigger.attr('aria-expanded', 'true');
    }

    var closeCallback = function()
    {
      closing = true;
      $target.removeClass(settings.activeClass);

      if ($wrapper && 0 < $wrapper.length) {
        $wrapper.removeClass(settings.activeClass);
      }

      if ($trigger.length > 0) {
        $trigger.removeClass(settings.activeClass);
      }

      // Disable the global closer handler.
      unregisterCloserHandler();

      $element.trigger(buildEvent('hiding'));

      // Register one handler for completion.
      $element.one(ModernizrHelper.getTransitionEndEvent(), $.proxy(onCloseCompleted, plugin));
      ModernizrHelper.emulateTransitionEnd($element[0], $.proxy(onCloseCompleted, plugin), settings.animationWait);
    }

    var onCloseCompleted = function()
    {
      closing = false;

      // Trigger some event to assess animation is over.
      $element.trigger(buildEvent('hidden'));
      $trigger.attr('aria-expanded', 'false');
    }

    var registerCloserHandler = function()
    {
      if ($wrapper && 0 < $wrapper.length) {
        $wrapper.on('click', onOpenedClick);
      }
    }

    var unregisterCloserHandler = function()
    {
      if ($wrapper && 0 < $wrapper.length) {
        $wrapper.off('click', onOpenedClick);
      }
    }

    var onOpenedClick = function(event)
    {
      var isElement = (event.target === $element[0]),
          isChild = ($element.has(event.target).length > 0),
          $eventTarget = $(event.target),
          isTrigger = ($eventTarget.is(settings.triggerSelector) || $eventTarget.closest(settings.triggerSelector).length)
      ;

      if (!isTrigger && ((!isElement && !isChild) || (isChild && $eventTarget.is(settings.closingWhitelist)))) {
        plugin.close();
      }
    }

    plugin.getTarget = function()
    {
      return $target;
    }

    plugin.isOpened = function()
    {
      return $target.hasClass(settings.activeClass);
    }

    plugin.isOpening = function()
    {
      return opening;
    }

    plugin.isClosing = function()
    {
      return closing;
    }

    plugin.toggle = function(eventTarget)
    {
      var
        $eventTarget = $(eventTarget),
        href = $trigger.attr('href'),
        isTrigger = eventTarget === $trigger[0] || $trigger.has(eventTarget).length > 0
      ;

      if (true === $trigger.data('go') && href && '#' !== href
        && (plugin.isOpened() || plugin.isOpening())
        && isTrigger
      ) {
        window.location.href = href;

        return true;
      }

      if (!plugin.isOpening() && !plugin.isOpened()) {

        return plugin.open();
      }

      return plugin.close();
    }

    plugin.open = function()
    {
      if (plugin.isOpened() || plugin.isOpening()) {

        return false;
      }

      return offieManager.closeAll(showCallback, offieManager.getParents(plugin), settings.group);
    }

    plugin.close = function()
    {
      if (!plugin.isOpened() || plugin.isClosing()) {

        return false;
      }

      return closeCallback();
    }

    plugin.getElement = function() {
      return $element;
    }

    var buildEvent = function(name) {
      return $.Event(getEventName(name), {
        'offie': plugin,
        'offieDropdown': plugin, // For BC
        'relatedTarget': $target
      });
    }

    var getEventName = function(name)
    {
      return name + '.jq' + '.' + PLUGIN_NAME;
    }

    init(element, options);
  };

  $.fn.offie = $.fn.offieDropdown = function(options) {
    return this.each(function() {
      if (undefined == $(this).data('offie') && undefined == $(this).data('offie-dropdown')) {
        var plugin = new Offie(this, options);
        $(this).data('offie-dropdown', plugin); // For BC
        $(this).data('offie', plugin);
      }
    });
  }

  // Create the "global" offie manager.
  var offieManager = new OffieManager();

  /**
   * DATA-* ATTRIBUTES API
   *
   * Use data-* attributes to enable/configure your offie components.
   */
  $(document).ready(function() {
    $('[data-toggle="offie"], [data-toggle="offie-dropdown"]').offie();
  });
}(jQuery, _, Modernizr, undefined, window));
